export const GET_SURVEY_QUESTIONS = "GET_SURVEY_QUESTIONS";
export const GET_SURVEY_QUESTIONS_SUCCESS = "GET_SURVEY_QUESTIONS_SUCCESS";

export const SUBMIT_SURVEY = "SUBMIT_SURVEY";
export const SUBMIT_SURVEY_SUCCESS = "SUBMIT_SURVEY_SUCCESS";
export const SUBMIT_SURVEY_PARTIAL_SUCCESS = "SUBMIT_SURVEY_PARTIAL_SUCCESS";

export const GET_FSP_PROFILE = "GET_FSP_PROFILE";
export const GET_FSP_PROFILE_SUCCESS = "GET_FSP_PROFILE_SUCCESS";

export const SET_SURVEY_RESPONSES = "SET_SURVEY_RESPONSES";

export const questionPrefix = "q";


// WEBPACK FOOTER //
// ./app/survey/constants/surveyConstants.js